import { create } from 'zustand';

export type ToastTone = 'ok' | 'att' | 'crit' | 'info';

export interface Toast {
  id: number;
  tone: ToastTone;
  title: string;
  detail?: string | undefined;
}

/** Durations of the design system (rule 16): 4 s green, 8 s amber, red never expires. */
const DURATION_MS: Record<ToastTone, number | null> = {
  ok: 4000,
  info: 4000,
  att: 8000,
  crit: null,
};

interface ToastState {
  toasts: Toast[];
  push: (toast: Omit<Toast, 'id'>) => void;
  dismiss: (id: number) => void;
}

let sequence = 0;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push(toast) {
    sequence += 1;
    const id = sequence;
    // One at a time: a new toast replaces the previous non-critical one.
    set({ toasts: [...get().toasts.filter((t) => t.tone === 'crit'), { ...toast, id }] });
    const duration = DURATION_MS[toast.tone];
    if (duration !== null) setTimeout(() => get().dismiss(id), duration);
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
}));

export function toast(tone: ToastTone, title: string, detail?: string): void {
  useToastStore.getState().push({ tone, title, detail });
}
